import { useAuth } from 'src/contexts/auth'
import { useUpdateAnimal, useCreateAnimalHistoric } from 'src/hooks/api/animal'
import { AnimalController } from 'src/controllers/animal.controller'

export const useAnimalSaleOperations = () => {
  const { userFarm: farmId } = useAuth()
  const { mutateAsync: updateAnimalMutation } = useUpdateAnimal()
  const { mutateAsync: createAnimalHistoricMutation } = useCreateAnimalHistoric()
  const animalController = new AnimalController()

  const updateAnimalsOnSale = async (animalIds: string[], saleDate?: Date | string) => {
    const now = new Date().toISOString()
    const saleDateIso = saleDate ? new Date(saleDate).toISOString() : now

    for (const animalId of animalIds) {
      try {
        const animalData = await animalController.getAnimalById(farmId!, animalId)

        if (!animalData) continue
        await updateAnimalMutation({
          ...animalData,
          dataVenda: saleDateIso,
          categoria: 'VD',
          dataAtual: now,
          tela: 'venda',
          acao: 'Atualizacao'
        })

        await createAnimalHistoricMutation({
          idFazenda: farmId!,
          idAnimal: animalId,
          idFazendaIdAnimal: `${farmId!}#${animalId}`,
          idHistorico: `${farmId!}#${animalId}`,
          idTransacao: null,
          data: now,
          peso: animalData.pesoAtual || 0,
          perimetro: animalData.perimetro || 0,
          observacoes: '',
          compra: false,
          nascimento: false,
          morte: false,
          venda: true,
          diagnostico: null,
          status: 'Processado',
          fitaComprimento: animalData.fitaComprimento || 0,
          fitaPerimetro: animalData.fitaPerimetro || 0,
          idProcessoMangueiro: null,
          categoria: 'VD',
          idPasto: animalData.idPastoAtual || '',
          descricao: animalData.nome || '',
          sexo: animalData.sexo,
          animalComprado: animalData.animalComprado || false,
          idLote: animalData.idLoteAtual || ''
        })
      } catch (error: any) {
        console.error(`Erro ao atualizar animal ${animalId}:`, error)
      }
    }
  }

  const revertAnimalsOnSaleDelete = async (animalIds: string[]) => {
    const now = new Date().toISOString()

    for (const animalId of animalIds) {
      try {
        const animalData = await animalController.getAnimalById(farmId!, animalId)

        if (!animalData) continue

        await updateAnimalMutation({
          ...animalData,
          categoria: null,
          dataVenda: null,
          dataAtual: now,
          tela: 'venda',
          acao: 'Atualizacao'
        })
      } catch (error: any) {
        console.error(`Erro ao reverter animal ${animalId}:`, error)
      }
    }
  }

  return {
    updateAnimalsOnSale,
    revertAnimalsOnSaleDelete
  }
}
